import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import OutletBasicInfo from "./outletBasicInfo";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import OutletForm from "../outletForm";
import { getOutlet } from "../../../../../services/sales/outletService";
import OutletStocks from "./outletStocks";
import OutletReceiveItems from "./outletReceiveItems";
import ItemsTransferList from "../../../inventory/stock-management/item-issue/items-transfer/itemsTransferList";
import OutletItemsRequest from "../../../inventory/stock-management/items-reservation/outletItemsRequest";
import ItemsReservationList from "../../../inventory/stock-management/items-reservation/itemsReservationList";
import DeliveryList from "../../../inventory/stock-management/delivery/deliveryList";
import ItemsMovementList from "../../../inventory/stock-management/items-movement/itemsMovementList";
import { Menubar } from "primereact/menubar";
import StocksCounting from "../../../inventory/stock-management/stock-counting/stocksCounting";
import SafeStockForm from "../../../inventory/stock-management/safe-stock/SafeStockForm";
import withGlobalData from "../../../common/withGlobalData";
import ItemSellForm from "./ItemSellForm";
import OutletCashAccountForm from "./OutletCashAccountForm";
class OutletDetail extends Component {
  state = {
    reload: this.props.globalData.reload,
    auth: {},
    component: null,
    open: false,
    selectedMenu: "outlet-info",
    selectedHeader: "",
    outlet: {},
    currencies: [],
    countries: [],
  };

  async componentDidMount() {
    this.getOutlet();
    this.getSelectedMenu();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getOutlet();
      this.getSelectedMenu();
      this.setState({ reload: globalData.reload });
    }
  }

  async getOutlet() {
    const { outletID } = this.props;
    const response = await getOutlet(outletID);
    const { data, auth } = response.data;
    const { outlet } = data;
    this.setState({
      outlet,
      auth,
    });
  }

  async getSelectedMenu() {
    const { setHeaderTitle } = this.props;
    let selectedHeaderParam = "";
    let selectedMenuParam = "";
    const urlSplit = window.location.href.split("/");
    selectedMenuParam = urlSplit[urlSplit.length - 1];

    if (selectedMenuParam === "outlet-info") {
      setHeaderTitle("Outlet Info");
      selectedHeaderParam = "";
    } else if (selectedMenuParam === "goods-received") {
      setHeaderTitle("Goods Received");
      selectedHeaderParam = "";
    } else if (selectedMenuParam === "pos-items-selling-price") {
      setHeaderTitle("POS Items Selling Price");
      selectedHeaderParam = "POS";
    } else if (selectedMenuParam === "pos-cash-account") {
      setHeaderTitle("POS Cash Setup");
      selectedHeaderParam = "POS";
    } else if (selectedMenuParam === "items-reservation") {
      setHeaderTitle("Items Reservation");
      selectedHeaderParam = "POS";
    } else if (selectedMenuParam === "goods-issued") {
      setHeaderTitle("Goods Issued");
      selectedHeaderParam = "POS";
    } else if (selectedMenuParam === "items-request") {
      setHeaderTitle("Items Request");
      selectedHeaderParam = "MANAGE_STOCK";
    } else if (selectedMenuParam === "items-transfer") {
      setHeaderTitle("Items Transfer");
      selectedHeaderParam = "MANAGE_STOCK";
    } else if (selectedMenuParam === "stock-opname") {
      setHeaderTitle("Stock Opname");
      selectedHeaderParam = "MANAGE_STOCK";
    } else if (selectedMenuParam === "safe-stock") {
      setHeaderTitle("Safe Stock");
      selectedHeaderParam = "MANAGE_STOCK";
    } else if (selectedMenuParam === "stock-movement") {
      setHeaderTitle("Stock Movement");
      selectedHeaderParam = "MANAGE_STOCK";
    } else if (selectedMenuParam === "stock-list") {
      setHeaderTitle("Stock List");
      selectedHeaderParam = "MANAGE_STOCK";
    }
    this.setState({
      selectedMenu: selectedMenuParam,
      selectedHeader: selectedHeaderParam,
    });
  }

  render() {
    const { setHeaderTitle, appCode, history } = this.props;
    const { outlet, open, selectedMenu, selectedHeader } = this.state;
    const posItems = [];
    const items = [];

    if (appCode === "OUTL" || appCode === "STMG") {
      items.push({
        label: "Outlet Info",
        icon: "fas fa-th-large",
        className: `${
          selectedMenu === `outlet-info` ? "p-menuitem-link-active" : ""
        }`,
        command: () => {
          this.setState({ selectedMenu: "outlet-info", selectedHeader: "" });
          setHeaderTitle("Outlet Info");
          if (appCode === "STMG") {
            history.push(
              `/inventory/stock-management/O/${outlet.ID}/outlet-info`
            );
          } else if (appCode === "OUTL") {
            history.push(`/sales/outlet-setting/${outlet.ID}/outlet-info`);
          }
        },
      });
    }

    if (appCode === "STMG") {
      items.push({
        label: "Goods Received",
        icon: "fas fa-truck-loading",
        className: `${
          selectedMenu === `goods-received` ? "p-menuitem-link-active" : ""
        }`,
        command: () => {
          this.setState({ selectedMenu: "goods-received", selectedHeader: "" });
          setHeaderTitle("Goods Received");
          history.push(
            `/inventory/stock-management/O/${outlet.ID}/goods-received`
          );
        },
      });
    }

    if (appCode === "OUTL") {
      posItems.push(
        {
          label: "Items Selling Price",
          icon: "fas fa-list-ul",
          className: `${
            selectedMenu === `pos-items-selling-price`
              ? "p-menuitem-link-active"
              : ""
          }`,
          command: () => {
            this.setState({
              selectedMenu: "pos-items-selling-price",
              selectedHeader: "POS",
            });
            setHeaderTitle("POS Items Selling Price");
            history.push(
              `/sales/outlet-setting/${outlet.ID}/pos-items-selling-price`
            );
          },
        },
        {
          label: "POS Cash Setup",
          icon: "fas fa-money-bill",
          className: `${
            selectedMenu === `pos-cash-account` ? "p-menuitem-link-active" : ""
          }`,
          command: () => {
            this.setState({
              selectedMenu: "pos-cash-account",
              selectedHeader: "POS",
            });
            setHeaderTitle("POS Cash Setup");
            history.push(`/sales/outlet-setting/${outlet.ID}/pos-cash-account`);
          },
        }
      );
    } else if (appCode === "STMG") {
      posItems.push(
        {
          label: "Items Reservation",
          icon: "fas fa-box-tissue",
          className: `${
            selectedMenu === `items-reservation` ? "p-menuitem-link-active" : ""
          }`,
          command: () => {
            this.setState({
              selectedMenu: "items-reservation",
              selectedHeader: "POS",
            });
            setHeaderTitle("Items Reservation");
            history.push(
              `/inventory/stock-management/O/${outlet.ID}/items-reservation`
            );
          },
        },
        {
          label: "Goods Issued",
          icon: "fas fa-shipping-fast",
          className: `${
            selectedMenu === `goods-issued` ? "p-menuitem-link-active" : ""
          }`,
          command: () => {
            this.setState({
              selectedMenu: "goods-issued",
              selectedHeader: "POS",
            });
            setHeaderTitle("Goods Issued");
            history.push(
              `/inventory/stock-management/O/${outlet.ID}/goods-issued`
            );
          },
        }
      );
    }

    items.push({
      label: "Point Of Sales",
      icon: "fas fa-chart-area",
      className: `${selectedHeader === `POS` ? "p-menuitem-link-active" : ""}`,
      items: posItems,
    });

    if (appCode === "STMG") {
      items.push({
        label: "Manage Stock",
        icon: "fas fa-boxes",
        className: `${
          selectedHeader === `MANAGE_STOCK` ? "p-menuitem-link-active" : ""
        }`,
        items: [
          {
            label: "Items Request",
            icon: "fas fa-box-open",
            className: `${
              selectedMenu === `items-request` ? "p-menuitem-link-active" : ""
            }`,
            command: () => {
              this.setState({
                selectedMenu: "items-request",
                selectedHeader: "MANAGE_STOCK",
              });
              setHeaderTitle("Items Request");
              history.push(
                `/inventory/stock-management/O/${outlet.ID}/items-request`
              );
            },
          },
          {
            label: "Items Transfer",
            icon: "fas fa-truck-moving",
            className: `${
              selectedMenu === `items-transfer` ? "p-menuitem-link-active" : ""
            }`,
            command: () => {
              this.setState({
                selectedMenu: "items-transfer",
                selectedHeader: "MANAGE_STOCK",
              });
              setHeaderTitle("Items Transfer");
              history.push(
                `/inventory/stock-management/O/${outlet.ID}/items-transfer`
              );
            },
          },
          {
            label: "Stock Opname",
            icon: "fas fa-calculator",
            className: `${
              selectedMenu === `stock-opname` ? "p-menuitem-link-active" : ""
            }`,
            command: () => {
              this.setState({
                selectedMenu: "stock-opname",
                selectedHeader: "MANAGE_STOCK",
              });
              setHeaderTitle("Stock Opname");
              history.push(
                `/inventory/stock-management/O/${outlet.ID}/stock-opname`
              );
            },
          },
          {
            label: "Safe Stock",
            icon: "fas fa-box",
            className: `${
              selectedMenu === `safe-stock` ? "p-menuitem-link-active" : ""
            }`,
            command: () => {
              this.setState({
                selectedMenu: "safe-stock",
                selectedHeader: "MANAGE_STOCK",
              });
              setHeaderTitle("Safe Stock");
              history.push(
                `/inventory/stock-management/O/${outlet.ID}/safe-stock`
              );
            },
          },
          {
            label: "Stock Movement",
            icon: "fas fa-luggage-cart",
            className: `${
              selectedMenu === `stock-movement` ? "p-menuitem-link-active" : ""
            }`,
            command: () => {
              this.setState({
                selectedMenu: "stock-movement",
                selectedHeader: "MANAGE_STOCK",
              });
              setHeaderTitle("Stock Movement");
              history.push(
                `/inventory/stock-management/O/${outlet.ID}/stock-movement`
              );
            },
          },
          {
            label: "Stock List",
            icon: "fas fa-clipboard-list",
            className: `${
              selectedMenu === `stock-list` ? "p-menuitem-link-active" : ""
            }`,
            command: () => {
              this.setState({
                selectedMenu: "stock-list",
                selectedHeader: "MANAGE_STOCK",
              });
              setHeaderTitle("Stock List");
              history.push(
                `/inventory/stock-management/O/${outlet.ID}/stock-list`
              );
            },
          },
        ],
      });
    }

    return (
      <React.Fragment>
        {outlet.ID > 0 ? (
          <ContentLayout>
            <Menubar model={items} />
            <div className="card menubar-content">
              <Switch>
                <Redirect
                  exact={true}
                  from={`/inventory/stock-management/O/${outlet.ID}`}
                  to={`/inventory/stock-management/O/${outlet.ID}/outlet-info`}
                />
                <Redirect
                  exact={true}
                  from={`/sales/outlet-setting/${outlet.ID}`}
                  to={`/sales/outlet-setting/${outlet.ID}/outlet-info`}
                />
                <Route
                  path="/inventory/stock-management/O/:outletID/outlet-info"
                  component={OutletBasicInfo}
                />
                <Route
                  path="/sales/outlet-setting/:outletID/outlet-info"
                  component={OutletBasicInfo}
                />
                <Route
                  path="/inventory/stock-management/O/:outletID/goods-received"
                  component={OutletReceiveItems}
                />
                <Route
                  path="/inventory/stock-management/O/:outletID/items-reservation"
                  component={ItemsReservationList}
                />
                <Route
                  path="/inventory/stock-management/O/:outletID/goods-issued"
                  component={DeliveryList}
                />
                <Route
                  path="/inventory/stock-management/O/:outletID/items-request"
                  component={OutletItemsRequest}
                />
                <Route
                  path="/inventory/stock-management/O/:outletID/items-transfer"
                  component={ItemsTransferList}
                />
                <Route
                  path="/inventory/stock-management/O/:outletID/stock-opname"
                  component={StocksCounting}
                />
                <Route
                  path="/inventory/stock-management/O/:outletID/safe-stock"
                  component={SafeStockForm}
                />
                <Route
                  path="/inventory/stock-management/O/:outletID/stock-movement"
                  component={ItemsMovementList}
                />
                <Route
                  path="/inventory/stock-management/O/:outletID/stock-list"
                  component={OutletStocks}
                />
                <Route
                  path="/sales/outlet-setting/:outletID/pos-items-selling-price"
                  component={ItemSellForm}
                />
                <Route
                  path="/sales/outlet-setting/:outletID/pos-cash-account"
                  component={OutletCashAccountForm}
                />
              </Switch>
            </div>
          </ContentLayout>
        ) : null}
        <DialogLayout
          open={open}
          title="Outlet Form"
          onCloseDialog={this.handleCloseDialog}
          maxWIdth="sm"
        >
          <OutletForm
            outlet={outlet}
            onCloseDialog={this.handleCloseDialog}
            onReloadOutlets={this.handleReloadOutlets}
          />
        </DialogLayout>
      </React.Fragment>
    );
  }
  handleReloadOutlets = () => {
    this.getOutlet();
    this.setState({ open: false });
  };

  handleOpenDialog = () => {
    this.setState({ open: true });
  };

  handleCloseDialog = () => {
    this.setState({ open: false });
  };
}

export default withGlobalData(OutletDetail);
